// extracted by mini-css-extract-plugin
export default {"card":"Card_card__pqOY8","card--dark":"Card_card--dark__xBvAQ","card--medium":"Card_card--medium__UxtVw"};